import { Fragment } from 'react'

import { NO_COLOR_OPTION_NAME } from '@src/quince-site-common/src/constants/app'

import type { ProductTileTitleProps } from './title.types'

/**
 * Accessible product title for design-system tiles: optionally prepends a screen-reader-only color name.
 */
export function ProductTileTitle({ title, colorDisplayName, renderLink }: ProductTileTitleProps) {
  const exposeColorToScreenReader =
    colorDisplayName && colorDisplayName.toLowerCase() !== NO_COLOR_OPTION_NAME.toLowerCase()

  const accessibleProductName = exposeColorToScreenReader ? (
    <>
      <span className="sr-only">{colorDisplayName}&nbsp;</span>
      {title}
    </>
  ) : (
    title
  )

  const content = renderLink ? renderLink(accessibleProductName) : accessibleProductName

  return <Fragment>{content}</Fragment>
}
